
import React from 'react';
import PlayPauseButton from './PlayPauseButton';
import SkipButton from './SkipButton';

interface TimerPlaybackControlsProps {
  isRunning: boolean;
  onTogglePlay: () => void;
  onPrevious: () => void;
  onNext: () => void;
  isMobile: boolean;
}

const TimerPlaybackControls: React.FC<TimerPlaybackControlsProps> = ({
  isRunning,
  onTogglePlay,
  onPrevious,
  onNext,
  isMobile
}) => {
  const handleToggle = () => {
    console.log("TimerPlaybackControls: toggle play/pause called");
    onTogglePlay();
  };

  return (
    <div className="mt-3 flex items-center justify-center space-x-4">
      <SkipButton 
        direction="previous"
        onClick={onPrevious}
        isMobile={isMobile}
      />
      
      <PlayPauseButton
        isRunning={isRunning}
        onToggle={handleToggle}
        isMobile={isMobile}
      />
      
      <SkipButton 
        direction="next"
        onClick={onNext}
        isMobile={isMobile}
      />
    </div>
  );
};

export default TimerPlaybackControls;
